import { ROUTE } from '@enums/route'
import { SegmentPage } from '@enums/segment'
import { ignoreCypress } from '@util/ignore-cypress'
import { Component } from 'react'
import { pageEvent } from './page'

// ssoSignIn = 'SSO Sign In',
// ssoSignUp = 'SSO Sign Up',

// a mapping of the paths to Data Science's names for each page
export const pathsToViews = new Map([
  [ROUTE.home, SegmentPage.home],
  [ROUTE.logIn, SegmentPage.logIn],
  [ROUTE.signUp, SegmentPage.signUp],
  [ROUTE.forgotPassword, SegmentPage.forgotPassword],
  [ROUTE.forgotPasswordConfirm, SegmentPage.resetPassword],
  [ROUTE.home, SegmentPage.home],
  [ROUTE.intro, SegmentPage.intro],
  [ROUTE.password, SegmentPage.password],
  [ROUTE.signUpDetails, SegmentPage.signUpDetails],
  // [ROUTE.course, SegmentPage.course],
  // [ROUTE.newHome, SegmentPage.newHome]
])

// contract expected by Data Science
type SegmentRoutePageEvent = {
  (view: ROUTE): void
}
const handlePageEvent: SegmentRoutePageEvent = (route) => {

  const name = pathsToViews.get(route) as SegmentPage
  if(!name) return
  pageEvent(name)
}

export const trackRoutePageEvent = ignoreCypress(handlePageEvent)
